import {
  MealDetailsConnectorApollo,
  TrackerAddMealConnectorApollo,
  useAppContext,
} from '@front-activerse/common-components';
import { useParams } from 'react-router-dom';
import TrackerAddMealContainer from './TrackerAddMealContainer';

const TrackerIndexPage = () => {
  const { dietMealId, mealType, userDietSetId } = useParams();
  const { post } = useAppContext();

  if (!dietMealId || !mealType || !userDietSetId) {
    return <div>Missing parameters</div>;
  }

  return (
    <MealDetailsConnectorApollo
      userDietSetId={+userDietSetId}
      mealType={+mealType}
      dietMealId={+dietMealId}
    >
      {({ ...mealData }) => (
        <TrackerAddMealConnectorApollo post={post}>
          {({ addMeal }: { addMeal: (input: any) => Promise<any> }) => (
            <TrackerAddMealContainer
              {...mealData.meal}
              loading={mealData.loading}
              addMeal={addMeal}
            />
          )}
        </TrackerAddMealConnectorApollo>
      )}
    </MealDetailsConnectorApollo>
  );
};

export default TrackerIndexPage;
